export default __webpack_public_path__ + "static/media/pyposition_84d.fae64505.png";